import React, {FC} from 'react';

import {supportsPopout} from '../../../libs/shared/core/src/helpers/environment/platformHelpers';
import {getHasPopoutComposerInP3} from '../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {ViewerPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {useAppSelector} from '../../helpers/appReduxHelpers';
import {ConversationModel} from '../../models/api/conversationModel';
import {InboxesVisualConversationSelection} from '../../store/panels/cells/helpers/cellsPanelSelectionHelpers';
import {ViewerPanelPageState} from '../../store/panels/viewer/viewerPanelState';
import {FrameTitle} from '../common/frames/frameTitle';
import {InboxesTopbar} from '../inboxes/topbar/inboxesTopbar';
import {ConversationHeaderContainer} from '../inboxes/viewer/conversation/header/conversationHeaderContainer';
import {ConversationSubjectContainer} from '../inboxes/viewer/conversation/header/conversationSubjectContainer';
import {ConversationTopbarContainer} from '../inboxes/viewer/conversation/topbar/conversationTopbarContainer';
import {ViewerContainer} from '../inboxes/viewer/viewerContainer';

/*
 * Props.
 */

interface PopupViewerConversationProps {
  panelId: ViewerPanelId;
  conversation: ConversationModel | undefined;
  page: ViewerPanelPageState;
  conversationSelection: InboxesVisualConversationSelection;
  shouldFocusComment?: boolean;
}

/*
 * Component.
 */

export const PopupViewerConversation: FC<PopupViewerConversationProps> = (props) => {
  const hasPopoutComposerInP3 = useAppSelector(getHasPopoutComposerInP3);
  const canComposerPopout = supportsPopout() && !hasPopoutComposerInP3;

  return (
    <>
      <FrameTitle>
        {props.conversation && (
          <ConversationSubjectContainer
            teammateId={props.page.cellsContext.teammateId}
            conversation={props.conversation}
          />
        )}
      </FrameTitle>
      <InboxesTopbar
        panelId={props.panelId}
        cellsPanelId={undefined}
        isInPopup
        filters={undefined}
        cellsContext={props.page.cellsContext}
        parameters={props.page.parameters}
        conversationSelection={props.conversationSelection}
      />
      <ViewerContainer
        cellsPanelId={undefined}
        panelId={props.panelId}
        isActive
        renderTopbar={({isOffline}) => (
          <ConversationTopbarContainer
            panelId={props.panelId}
            cellsPanelId={undefined}
            isInPopup
            cellsContext={props.page.cellsContext}
            inboxesParameters={props.page.parameters}
            conversationSelection={props.conversationSelection}
            isOffline={isOffline}
          />
        )}
        renderHeader={() => (
          <ConversationHeaderContainer
            panelId={props.panelId}
            cellsPanelId={undefined}
            cellsContext={props.page.cellsContext}
            inboxesParameters={props.page.parameters}
            conversationSelection={props.conversationSelection}
          />
        )}
        contentPage={props.page}
        canComposerPopout={canComposerPopout}
      />
    </>
  );
};
